<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'
const moment = require('moment')

export default {
  name: 'CourseClassesTab',
  props: ['courseForm', 'validation'],
  components: {
    Grid
  },
  data () {
    return {
      moment: moment,
      module: this.$route.meta.module,
      columnOptions: [
        // { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'CLASS_START_DATE', name: 'CLASS_START_DATE', label: 'Class Start Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'CLASS_END_DATE', name: 'CLASS_END_DATE', label: 'Class End Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: false, filterable: false, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapState('courses', {
      classes: state => state.courseClassList,
    }),
    ...mapGetters('courses', [
    ])
  },
  methods: {
    ...mapActions('courses', [
      'fetchCourseClasses',
      'viewCourseClass'
    ]),
    ...mapMutations('courses', [
    ])
  }
}
</script>

<template>
  <div class="fit">
    <Grid
      :module="module"
      :data="classes"
      :columns="columnOptions"
      :onLaunch="viewCourseClass"
      :onRequest="fetchCourseClasses"
    />
  </div>
</template>

<style>
</style>
